<template>
    <div class="review-wrapper p-4">
        <img class="mw-100 rounded mb-4" :src="image"/>
        <div class="text-center mb-4">{{ text_message }}</div>
        <rating-stars
            class="rating-stars mt-4 d-flex flex-wrap justify-content-center mb-4"
            v-if="rating"
            v-model="form.rating"
            style="font-size: 1.8em;"
        />

        <textarea
            class="form-control mb-4"
            v-model="form.body"
        />

        <small class="invalid-feedback" v-if="form.errors.has('body')">
            {{ form.errors.get('body') }}
        </small>
        <div class="d-flex justify-content-center d-flex flex-column">
            <button-loading
                class="btn swell-btn btn-primary mb-1"
                @click="$emit('submit', form.body)"
                :loading="form.submitting">
                {{ text_submit }}
            </button-loading>
            <button class="btn swell-btn btn-link mb-1" @click="$emit('back')" v-if="!hideBackButton">
                {{ text_back }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            form          : {default: () => (new Form({body: null}))},
            image         : String,
            text          : {default: null},
            textSubmit    : {default: null},
            textBack      : {default: null},
            hideBackButton: {default: false},
            rating        : {default: false},
        },

        computed: {
            text_message() {
                return this.text || 'Please tell us more about your experience';
            },
            text_submit() {
                return this.textSubmit || 'Submit'
            },
            text_back() {
                return this.textBack || 'Back'
            },
        },
    }
</script>

<style lang="scss" scoped>
    textarea {
        min-height: 80px;
    }
</style>
